import { memo, FC, useContext, useMemo, useEffect } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { Menu } from './menu';
import { Icon } from '@iconify/react';
import './style.css';
import { toolTipAtrributes } from '../../utils';
import { Context } from 'src/context';




const Sidebar = () => {

    const { t, i18n } = useTranslation()
    const { state, pathname } = useLocation()
    const navigate = useNavigate()

    const { authorizedPages, setSearchData, setSearchTypes, sideBarCollapsed } = useContext(Context)

    const handlClick = (link: string) => {
        if (link == pathname) return

        setSearchData([])
        setSearchTypes({})
    }

    const homeClick = () => {
        handlClick('/')
        navigate('/', { state: { ...state } })
    }


    const AccessedIdes = useMemo(() => authorizedPages?.map(ap => ap.id) || [], [authorizedPages])


    return (
        <nav id="sidebar" className={`${i18n.language} ${sideBarCollapsed ? 'collapsedSideBar' : 'active'} ${!sideBarCollapsed ? "opened" : ""}`} >
            <div className='logo-container pointer' onClick={homeClick}>
                <img src='images/MHP_logo.png' className={`logoImg ${sideBarCollapsed ? '' : 'closed-menu'}`} />
            </div>
            <ul className={`list-unstyled components `} >
                {Menu.filter(item => !!item.id.filter(sId => AccessedIdes.includes(sId))?.length).map(m =>
                    //@ts-ignore
                    <li key={m.id} {...toolTipAtrributes(t(m.name) || "", "", sideBarCollapsed)} onClick={() => handlClick(m.path)}>
                        <NavLink to={m.path} state={state}  >
                            <Icon icon={m.icon} className="SideBarIcons" />

                            {sideBarCollapsed ? <span>{t(m.name)}</span> : ""}
                        </NavLink>
                    </li>
                )}
            </ul>
        </nav >
    );
}

export default memo(Sidebar);
